// extracted by mini-css-extract-plugin
export var content = "style-module--content--STP-s";
export var imglyTypoButton = "style-module--imgly--typo-button--mZ07Z";
export var imglyTypoButtonSmall = "style-module--imgly--typo-button-small--17FPy";
export var imglyTypoH1 = "style-module--imgly--typo-h1--5xPpg";
export var imglyTypoH2 = "style-module--imgly--typo-h2--po0uA";
export var imglyTypoH2BodyText = "style-module--imgly--typo-h2-body-text--iYUAP";
export var imglyTypoH3 = "style-module--imgly--typo-h3--xR5w5";
export var imglyTypoH3BodyText = "style-module--imgly--typo-h3-body-text--CnsVr";
export var imglyTypoH4 = "style-module--imgly--typo-h4--nastG";
export var imglyTypoH5 = "style-module--imgly--typo-h5--iZ+PA";
export var imglyTypoH5IsSmall = "style-module--imgly--typo-h5-is-small--CToYQ";
export var imglyTypoIcon = "style-module--imgly--typo-icon--g2Pm7";
export var imglyTypoLink = "style-module--imgly--typo-link--IRb4r";
export var imglyTypoOverline = "style-module--imgly--typo-overline--wunVU";
export var imglyTypoOverlineSmall = "style-module--imgly--typo-overline-small--sHX8Y";
export var imglyTypoParagraph = "style-module--imgly--typo-paragraph--zE7Xb";
export var imglyTypoParagraphBig = "style-module--imgly--typo-paragraph-big--xapl4";
export var imglyTypoParagraphBodyText = "style-module--imgly--typo-paragraph-body-text--kZ3oq";
export var imglyTypoParagraphSmall = "style-module--imgly--typo-paragraph-small--eOTFC";
export var imglyTypoSubline = "style-module--imgly--typo-subline--AsgpK";
export var imglyTypoSublineBodyText = "style-module--imgly--typo-subline-body-text--a-8IX";
export var main = "style-module--main--vdXux";
export var naviLabelIsLarge = "style-module--navi-label-is-large--w0R0h";
export var naviLabelIsSmall = "style-module--navi-label-is-small--SW7oN";